import React from "react";

export default function StudentLoginBackground({
  children = null,
}: {
  children?: React.ReactNode;
}) {
  return (
    <>
      <style>{`
        .slbg-root {
          position: fixed;
          inset: 0;
          overflow: hidden;
          background: linear-gradient(135deg, #0f1117 0%, #1a1d2e 40%, #1e2340 70%, #141824 100%);
        }

        /* Subtle breathing glow — top-left */
        .slbg-root::before {
          content: '';
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 60% 50% at 15% 20%, rgba(99, 102, 241, 0.12) 0%, transparent 70%),
            radial-gradient(ellipse 50% 40% at 85% 75%, rgba(59, 130, 246, 0.10) 0%, transparent 65%);
          animation: slbg-shift 12s ease-in-out infinite alternate;
          pointer-events: none;
          z-index: 0;
        }

        /* Subtle breathing glow — bottom-right */
        .slbg-root::after {
          content: '';
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 45% 35% at 70% 10%, rgba(139, 92, 246, 0.08) 0%, transparent 65%),
            radial-gradient(ellipse 55% 45% at 30% 85%, rgba(14, 165, 233, 0.07) 0%, transparent 65%);
          animation: slbg-shift 16s ease-in-out infinite alternate-reverse;
          pointer-events: none;
          z-index: 1;
        }

        @keyframes slbg-shift {
          0%   { opacity: 0.6; transform: scale(1)    translate(0px,   0px); }
          50%  { opacity: 1;   transform: scale(1.08) translate(18px, -12px); }
          100% { opacity: 0.7; transform: scale(0.96) translate(-10px,  16px); }
        }

        .slbg-content {
          position: relative;
          z-index: 10;
          width: 100%;
          height: 100%;
        }
      `}</style>

      <div className="slbg-root">
        {children && <div className="slbg-content">{children}</div>}
      </div>
    </>
  );
}
